module.exports = __webpack_public_path__ + "img/blog7.ee26b0b2.jpg";